import { isObject } from 'lodash'
import React, { useState } from 'react'
import { Rnd } from 'react-rnd'
import styled from 'styled-components'

import Button from '../Button'
import JsonView from '../JsonView'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
`

const Inner = styled.div`
  overflow-y: auto;
  max-height: 500px;
  min-height: 500px;
  max-width: 500px;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.75);
  background: white;
`

type TGlobalUserLogger = {
  item: {
    [key: string]: any
  }
}

const GlobalUserLogger = (
  props: TGlobalUserLogger,
): React.ReactElement | null => {
  const { item } = props
  const [show, setShow] = useState(false)
  //console.log("item", item)
  if (!isObject(item)) return null

  return (
    <React.Fragment>
      <Button
        textOnly
        icon="fas fa-info-circle"
        onClick={() => setShow(!show)}
      />
      {show && (
        <Wrapper>
          <Rnd
            default={{
              x: 500,
              y: 250,
              width: 800,
              height: 500,
            }}
            bounds="window"
          >
            <Inner>
              <JsonView json={item} hideRoot />
            </Inner>
          </Rnd>
        </Wrapper>
      )}
    </React.Fragment>
  )
}

export default GlobalUserLogger
